import { createActions } from 'utils/actions';

/**
 * Redux actions for create questionnaire.
 *
 * @type {Object}
 */
export const fetchSecretsByGroupId = createActions('webhook', 'FETCH_SECRETS_BY_GROUP_ID', {
    asPromise: true,
});

export const createSecretByGroupId = createActions('webhook', 'CREATE_SECRET_BY_GROUP_ID', {
    asPromise: true,
});

export const fetchWebhookRules = createActions('webhook', 'FETCH_WEBHOOK_RULES', {
    asPromise: true,
});

export const createWebhookRule = createActions('webhook', 'CREATE_WEBHOOK_RULE', {
    asPromise: true,
});

export const deleteWebhookRules = createActions('webhook', 'DELETE_WEBHOOK_RULES', {
    asPromise: true,
});
